const ServiceProviderSharedPasswordType = Symbol();

// SPIDの最大長
export const ServiceProviderSharedPasswordMaxLength = 200;

export class ServiceProviderSharedPassword {
    [ServiceProviderSharedPasswordType]: any;
    readonly value: string;

    private constructor(sharedPassword: string) {
        this.value = sharedPassword;
    }

    static fromString(sharedPassword: string): ServiceProviderSharedPassword {
        return new ServiceProviderSharedPassword(sharedPassword);
    }

    static fromNothing(): ServiceProviderSharedPassword {
        return new ServiceProviderSharedPassword("");
    }

    // 共有パスワードの長さチェック
    isValidLength(): boolean {
        return !!this.value.length && !(this.value.length > ServiceProviderSharedPasswordMaxLength);
    }
}
